import React, { useState, useEffect } from "react";
import LineBtn from "../../../Button/LineBtn";
import DefaultModalLayout, {
  ModalFixedBox,
} from "../../../Modal/DefaultModalLayout";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import { ModalRowContentContainer } from "../../AlimTalk/AlimTalkModal";
import dayjs from "dayjs";
import { StatusCodeBoxContainer } from "../../AlimTalk/AlimTalkModal/StatusCodeBox";
import Blank from "../../../DefaultStyles/Blank";
import { useApi } from "../../../../hooks/useApi";
import { toast } from "react-toastify";
import Loader from "../../../DefaultStyles/Loader";

interface AllSendMesssageProps {
  totalCount: number;
}

export default function AllSendMesssage({ totalCount }: AllSendMesssageProps) {
  const [lmsModal, setLmsModal] = useState(false);
  const [sendMessage, setSendMessage] = useState(false);
  const [result, setResult] = useState({
    modal: false,
    total: 0,
    success: 0,
  });

  const { response, loading, error } = useApi({
    method: "post",
    url: sendMessage ? "pay/sendMessage" : undefined,
    data: {
      type: 0,
    },
  });

  useEffect(() => {
    if (response?.status === 201 || response?.status === 200) {
      setResult({
        modal: true,
        success: response?.data?.success,
        total: response?.data?.total,
      });
      toast.success("LMS를 보냈습니다.");
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "일괄 LMS 전송에 실패하였습니다.");
    }
  }, [error]);

  return (
    <>
      <LineBtn
        btnText="전체 LMS 보내기"
        icon="verified_user"
        btnHeight={38}
        btnClickEvent={() => setLmsModal(true)}
      />

      {loading && <Loader />}

      {lmsModal && (
        <DefaultModalLayout
          closeEvent={() => setLmsModal(false)}
          confirmEvent={() => {
            setSendMessage(true);
            setLmsModal(false);
          }}
          modalTitle="결제 실패 LMS 보내기"
          confirmBtnText="보내기"
        >
          <ModalRow>
            <ModalLabel>대상</ModalLabel>

            <ModalRowContentContainer>
              <ModalFixedBox style={{ fontWeight: 500 }}>
                {totalCount ?? 0}명, {dayjs().format("YYYY.M.D HH:mm")} 기준
              </ModalFixedBox>
            </ModalRowContentContainer>
          </ModalRow>

          <ModalRow>
            <ModalLabel>제목</ModalLabel>

            <ModalRowContentContainer>
              <ModalFixedBox style={{ fontWeight: 500 }}>
                정기결제 실패
              </ModalFixedBox>
            </ModalRowContentContainer>
          </ModalRow>

          <ModalLabel>내용</ModalLabel>

          <Blank blankHeight={16} />

          <StatusCodeBoxContainer
            style={{
              marginBottom: 20,
              whiteSpace: "pre-line",
              lineBreak: "anywhere",
            }}
          >
            {`안녕하세요. #{이름}님.
링키드 고객센터입니다.

■ 고객님의 아래와 같은 이유로 결제에 실패했습니다. 오늘 23시에 진행될 최종 결제에 실패할 경우, 링키드 파티 정책에 따라 자동으로 파티 탈퇴가 진행됩니다.

【 결제 실패 상세 】
① 이유: #{이유}
② 금액: #{금액}

▶ 해당 결제 실패 이유를 참고하시어 결제가 가능한 다른 신용/체크카드로 등록하시거나, 체크카드와 연결된 계좌의 잔액을 충전 바랍니다.
  
【 결제 수단 변경 방법 】
① 링키드 마이페이지
② 정산 수단 관리
③ 결제 수단 관리
④ 변경하기 진행
※ '인출 계좌 관리'는 결제와 관련이 없으므로 각별한 주의 바랍니다.

결제 수단 오류로 인해 최종 결제에 실패할 경우, 해당 파티에서 자동 탈퇴 처리되며, 탈퇴 시 보증금은 파티장님께 보상 처리되므로 각별한 주의와 빠른 조치 바랍니다.

관련하여 문의사항이 있으신 경우, 아래 링키드 고객센터로 연락 바랍니다.

【 링키드 고객센터 】
https://linkid.pw/help/chat/

감사합니다.
`}
          </StatusCodeBoxContainer>
        </DefaultModalLayout>
      )}

      {result.modal && (
        <DefaultModalLayout
          closeEvent={() =>
            setResult((prev) => ({
              ...prev,
              modal: false,
            }))
          }
          modalTitle="LMS 일괄 전송 내역"
          confirmEvent={() => {
            setResult((prev) => ({
              ...prev,
              modal: false,
            }));
          }}
          confirmBtnText="확인"
          cancelBtn={<></>}
          isMediumModal={true}
        >
          <ModalFixedBox>총 {result.total}명</ModalFixedBox>

          <Blank blankHeight={14} />

          <ModalLabel>내용 확인</ModalLabel>

          <ModalFixedBox>전송 성공: {result.success}명</ModalFixedBox>

          <ModalFixedBox>
            전송 실패: {result.total - result.success}명
          </ModalFixedBox>
        </DefaultModalLayout>
      )}
    </>
  );
}
